import { PageModule } from "@/routes/types";
import { loader } from "./loader";
import { Page } from "./page";

export default { name: "ProjectDiscussionNewPage", loader, Page } as PageModule;
